import axios from 'axios'

export default () => {
  return axios.create({
    baseURL: 'https://filmklubb.millving.se/api'
  })
}



// WEBPACK FOOTER //
// ./src/services/api.js